import { FC } from 'react'

// --
// -- A plain spinner. The shared <Loading /> rotates the brand logo image, which
// -- reads as a broken asset rather than progress, and picks a brand the public
// -- PartsCare page has no reason to assume.
// --
const Spinner: FC<{ label?: string; isfullScreen?: boolean }> = ({
  label = 'Loading',
  isfullScreen,
}) => (
  <div
    role='status'
    aria-live='polite'
    className={`
      flex justify-center items-center w-full gap-3 py-8
      ${isfullScreen ? 'min-h-screen' : 'min-h-full'}
    `}
  >
    <svg
      className='animate-spin h-5 w-5 text-[#80B742]'
      viewBox='0 0 24 24'
      fill='none'
      aria-hidden='true'
    >
      <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
      <path
        className='opacity-75'
        fill='currentColor'
        d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z'
      />
    </svg>
    <span className='text-gray-600 text-sm'>{label}</span>
  </div>
)

export default Spinner
